import { useAppDispatch } from '../hooks';
import { setIsAutoThemeAction, setIsDarkThemeAction } from '../reducers/themeReducer';

export const useThemeActions = () => {

    const dispatch = useAppDispatch();

    const setDarkTheme = (isDarkTheme: boolean) => {
        dispatch(setIsDarkThemeAction(isDarkTheme));
    }

    const setAutoTheme = (isAutoTheme: boolean) => {
        dispatch(setIsAutoThemeAction(isAutoTheme));
    }

    return { setDarkTheme, setAutoTheme };
}